import React,{useContext} from 'react'
import { LoginScreen } from '../components/login/LoginScreen';
import { DashboardRoutes } from './DashboardRoutes';
import { PrivateRauter } from './PrivateRauter';
import { PublicRauter } from './PublicRauter';
import { AuthContext } from '../auth/AuthContexts';

import {
    BrowserRouter as Router,
    Switch,
} from "react-router-dom";




export const AppRouter = () => {


    const {user} = useContext(AuthContext);
    
    return (
        <Router>
            <div>
                <Switch>
                    <PublicRauter  path='/login' isAuthenticated={user.logged} component={LoginScreen} />

                    <PrivateRauter path='/' isAuthenticated={user.logged} component={DashboardRoutes} />
                    
                </Switch>
            </div>
        </Router>
    )
}


//el Dash... (es el que tiene la barra y los universos
//tiene mas rutas dentro de el y pordefecto esta marvel